// src/pages/Home.js
import React, { useState } from 'react';
import { SimpleGrid, Box, useColorModeValue, Heading, Text } from '@chakra-ui/react';
import { FaTemperatureHigh, FaMapMarkerAlt, FaCloud, FaIndustry, FaBolt, FaPlus, FaCamera, FaFire, FaWaveSquare, FaTachometerAlt, FaTint, FaVolumeUp } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import SensorCard from '../components/SensorCard'; // Make sure SensorCard is updated to use icons properly
import { useTranslation } from 'react-i18next';
import { saveSensorInteraction } from '../utils/firebase.utils';
import * as amplitude from '@amplitude/analytics-browser';

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const bgColor = useColorModeValue('background', 'primary');


  const sensors = [
    { title_key: "temp_humidity", icon: <FaTemperatureHigh size="50"/>, desc_key: "temp_humidity_desc" },
    { title_key: "gps_location", icon: <FaMapMarkerAlt size="50"/>, desc_key: "gps_location_desc" },
    { title_key: "smoke_fire", icon: <FaFire size="50"/>, desc_key: "smoke_fire_desc" },
    { title_key: "vibration", icon: <FaWaveSquare size="50"/>, desc_key: "vibration_desc" },
    { title_key: "pressure", icon: <FaTachometerAlt size="50"/>, desc_key: "pressure_desc" },
    { title_key: "liquid_level", icon: <FaTint size="50"/>, desc_key: "liquid_level_desc" },
    { title_key: "noise", icon: <FaVolumeUp size="50"/>, desc_key: "noise_desc" },
    { title_key: "air_quality", icon: <FaCloud size="50"/>, desc_key: "air_quality_desc" },
    { title_key: "camera_tracking", icon: <FaCamera size="50"/>, desc_key: "camera_tracking_desc" },
    { title_key: "weather_monitoring", icon: <FaBolt size="50"/>, desc_key: "weather_monitoring_desc" },
    { title_key: "industrial_monitoring", icon: <FaIndustry size="50"/>, desc_key: "industrial_monitoring_desc" },
    { title_key: "new_sensor", icon: <FaPlus size="50"/>, desc_key: "new_sensor_desc" }
  ];

  const handleSensorClick = async (titleKey) => {
    setIsLoading(true);
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    try {
      await saveSensorInteraction(userData, t(titleKey));
      amplitude.track('Click Sensor', { sensor: t(titleKey) });
      navigate(`/request-sensor?sensor=${encodeURIComponent(t(titleKey))}`);
    } catch (error) {
      console.error("Error handling sensor click:", error);
      navigate('/');
    }
    finally {
      setIsLoading(false);
    }
  };

  return (
    <Box marginX="10%" marginY="0%" bg="white" p="5" borderRadius="lg" boxShadow="sm">
        <Heading color="headingColor" mb={4}>
        {t('exploreOurSensors')}
      </Heading>
      <Text fontSize="lg" mb={8} color="textSecondary">
        {t('chooseSensorSubtitle')}
      </Text>
<SimpleGrid columns={{ sm: 2, md: 3, lg: 4 }} spacing="20px">
      {sensors.map((sensor, index) => (
        <SensorCard
          key={index}
          title={t(sensor.title_key)}
          description={t(sensor.desc_key)}
          icon={sensor.icon}
          onClick={() => handleSensorClick(sensor.title_key)}
        />
      ))}
    </SimpleGrid>
  </Box>
  );
};

export default Home;